module.exports = __webpack_public_path__ + "img/checkup-img-event@3x.da1e0599.png";